import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getMeasuredUsingConfig = (prefix: string) => {
  const balance = wrap(`${prefix}.Preparation.Balance`);
  return {
    [`${prefix}.Preparation.TareMass`]: balance,
    [`${prefix}.Preparation.TareAndTotalSampleMass`]: balance,
    [`${prefix}.Preparation.TestPortionMass`]: balance,
    [`${prefix}.Preparation.TotalSampleDryMass`]: balance,
    [`${prefix}.Preparation.MassRetainedOn20_0mmSieve`]: balance,
  };
};

export default getMeasuredUsingConfig;
